module.exports = __webpack_public_path__ + "static/media/returnMain.a007bfdf.webp";